import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import TextFieldsIcon from "@mui/icons-material/TextFields";
import DescriptionIcon from "@mui/icons-material/Description";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import PersonIcon from "@mui/icons-material/Person";
import BarChartIcon from "@mui/icons-material/BarChart";

import StatisticsForm from "./components/StatisticsForm";

import NavigationFooter from "../../../helper-components/misc/NavigationFooter";
import CustomForm from "../../../helper-components/form/CustomForm";

import { getLanguage } from "../../../config/language/language";

/**
 * The statistics page.
 */
export default function Statistics(props) {
    const isLoggedIn = props.user.isLoggedIn;

    return (
        <Container maxWidth="xl" sx={{ mb: 2, mt: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12} className="tour-about-4">
                    <CustomForm title={getLanguage().STATISTICS_TITLE} subtitle={getLanguage().STATISTICS_SUBTITLE} icon={<BarChartIcon />} />
                </Grid>

                {isLoggedIn && <StatisticsForm {...props} />}

                {isLoggedIn && (
                    <NavigationFooter
                        rows={2}
                        options={[
                            {
                                path: `/database/resources`,
                                title: "Resources",
                                variant: "outlined",
                                icon: <DescriptionIcon />
                            },
                            {
                                path: `/database/transcripts`,
                                title: "Transcripts",
                                variant: "outlined",
                                icon: <TextFieldsIcon />
                            },
                            {
                                path: `/database/quotes`,
                                title: "Quotes",
                                variant: "outlined",
                                icon: <FormatQuoteIcon />
                            },
                            {
                                path: `/database/authors`,
                                title: "Authors",
                                variant: "outlined",
                                icon: <PersonIcon />
                            }
                        ]}
                    />
                )}
            </Grid>
        </Container>
    );
}
